import styled, { css } from 'styled-components';

const TRANSPARENT_BOX_SELECTOR = '[data-name="Transparent Bounding Box (Export)"], [fill="none"]:not(g)';
// Helper function to process numerical props. *** Note: Move to internal functions file when available.
export const parseNumberProp = (property, append = 'px') => {
  if (property) {
    if (typeof property === 'string') {
      return property;
    } else if (typeof property === 'number') {
      return property + append;
    }
  }
  return false;
};

const styles = {
  IconSvgWrapper: styled.div`
    display: flex;
    height: ${({ size }) => (size.height ? parseNumberProp(size.height) : parseNumberProp(size))};
    width: ${({ size }) => (size.width ? parseNumberProp(size.width) : parseNumberProp(size))};
    div {
      width: 100%;
      height: 100%;
      div {
        display: flex;
        align-items: center;
        justify-content: center
      }
    }
  `,
  Icon: styled.div`
    & svg {
      ${({ RTL, rtlSVG }) =>
    RTL &&
        !rtlSVG &&
        css`
          transform: scale(-1, 1);
        `}
      height: 100%;
      width: 100%;
      ${TRANSPARENT_BOX_SELECTOR} {
        display: none;
      }
      * {
        fill: ${({ $theme, retainColor, $color }) => !retainColor && ($color || $theme.color)};
      }
    }
  `
};

export default styles;
